// eslint-disable-next-line import/prefer-default-export
export const adRecoverScriptString = `window.adRecoverInterval = setInterval(() => {
                if(window.geoinfo && window.geoinfo.CountryCode !== 'IN' && window.geoinfo.Continent !== 'EU'){
                    clearInterval(window.adRecoverInterval);(function(w, d) { var s = d.createElement('script'); s.src = '//delivery.adrecover.com/39799/adRecover.js?ts=1570619213772'; s.type = 'text/javascript'; s.async = true; (d.getElementsByTagName('head')[0] || d.getElementsByTagName('body')[0]).appendChild(s); })(window, document);
                }
            }, 1000);
    `;
